import type { ReactElement } from 'react';
import { useMemo } from 'react';
import type { CtxRouter, PpWC } from '@noah-labs/fe-shared-ui-shared';
import { RouterContext } from '@noah-labs/fe-shared-ui-shared';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useOnRouteChange } from '../hooks/useOnRouteChange';

export function RouterProvider({ children }: PpWC): ReactElement {
  const history = useHistory();
  const location = useLocation();

  const routerValue = useMemo<CtxRouter>(
    () => ({
      goBack: (): void => history.goBack(),
      goForward: (): void => history.goForward(),
      location,
      pathname: location.pathname,
      push: (to): void => history.push(to),
      replace: (to): void => history.replace(to),
      search: new URLSearchParams(location.search),
      useOnRouteChange,
      useParams,
    }),
    [history, location],
  );

  return <RouterContext.Provider value={routerValue}>{children}</RouterContext.Provider>;
}
